import React, { Component } from 'react';

import { directoryUrl } from 'settings';

const onLoad = () => {
  document.body.classList.add('no-scroll');
};

export default class DirectoryView extends Component {
  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  render() {
    return (
      <div className="directory__view">
        <iframe
          title={`${directoryUrl}?${Date.now()}`}
          src={directoryUrl}
          onLoad={onLoad}
        />
      </div>
    );
  }
}
